export const OrderListConstants = {
    StoreSliceName: 'orderList'

}